/* eslint-disable */
export default {
  _HelpDisplay_n: 'HelpDisplay_n',
  _mm_assets_ResultsCircles: 'mm_assets/ResultsCircles',
  _DropHelpOverlay: 'DropHelpOverlay',
  _mm_assets_ButtonBackground: 'mm_assets/ButtonBackground',
  _mm_assets_CounterBoxShadows: 'mm_assets/CounterBoxShadows',
  _mm_assets_QuestionBubble: 'mm_assets/QuestionBubble',
  _mm_assets_RoundSelect6: 'mm_assets/RoundSelect6',
  _PenguinTalking_31: 'PenguinTalking/31',
  _PenguinTalking_32: 'PenguinTalking/32',
  _PenguinTalking_40: 'PenguinTalking/40',
  _PenguinTalking_47: 'PenguinTalking/47',
  _PenguinTalking_49: 'PenguinTalking/49',
  _PenguinTalking_50: 'PenguinTalking/50',
  _PenguinTalking_51: 'PenguinTalking/51',
  _PenguinTalking_80: 'PenguinTalking/80',
  _PenguinTalking_81: 'PenguinTalking/81',
  _PenguinTalking_86: 'PenguinTalking/86',
  _PenguinTalking_90: 'PenguinTalking/90',
  _PenguinTalking_92: 'PenguinTalking/92',
  _PenguinTalking_93: 'PenguinTalking/93',
  _PenguinTalking_1: 'PenguinTalking/1',
  _PenguinTalking_18: 'PenguinTalking/18',
  _PenguinTalking_19: 'PenguinTalking/19',
  _mm_assets_RoundSelectPenguinShadow: 'mm_assets/RoundSelectPenguinShadow',
  _mm_assets_QuestionIndicatorBg: 'mm_assets/QuestionIndicatorBg',
  _DropBox: 'DropBox',
  _mmAnimations_141: 'mmAnimations/141',
  _mmAnimations_140: 'mmAnimations/140',
  _mmAnimations_160: 'mmAnimations/160',
  _mmAnimations_142: 'mmAnimations/142',
  _mmAnimations_150: 'mmAnimations/150',
  _mmAnimations_41: 'mmAnimations/41',
  _md_assets_BtnBackWithShadow: 'md_assets/BtnBackWithShadow',
  _mm_common_assets_BtnGo: 'mm_common_assets/BtnGo',
  _mm_assets_BtnNextLevel: 'mm_assets/BtnNextLevel',
  _mm_assets_BtnTryAgain: 'mm_assets/BtnTryAgain',
  _mm_assets_HintDisplay: 'mm_assets/HintDisplay',
  _mm_assets_RoundSelect2: 'mm_assets/RoundSelect2',
  _mm_assets_RoundSelect3: 'mm_assets/RoundSelect3',
  _mm_assets_RoundSelect4: 'mm_assets/RoundSelect4',
  _md_assets_ArrowOn: 'md_assets/ArrowOn',
  _md_assets_ArrowRight: 'md_assets/ArrowRight',
  _MarbleDropAnimationSmall_14: 'MarbleDropAnimationSmall/14',
  _md_assets_DropCorrectMark: 'md_assets/DropCorrectMark',
  _mm_assets_MarbleShadow: 'mm_assets/MarbleShadow',
  _MarbleDropAnimationSmall_10: 'MarbleDropAnimationSmall/10',
  _mmAnimations_4: 'mmAnimations/4',
  _MarbleDropAnimationSmall_13: 'MarbleDropAnimationSmall/13',
  _MarbleDropAnimationSmall_0: 'MarbleDropAnimationSmall/0',
  _mmAnimations_15: 'mmAnimations/15',
  _mmAnimations_16: 'mmAnimations/16',
  _MarbleDropAnimationSmall_11: 'MarbleDropAnimationSmall/11',
  _MarbleDropAnimationSmall_15: 'MarbleDropAnimationSmall/15',
  _MarbleDropAnimationSmall_4: 'MarbleDropAnimationSmall/4',
  _MarbleDropAnimationSmall_5: 'MarbleDropAnimationSmall/5',
  _mmAnimations_17: 'mmAnimations/17',
  _MarbleDropAnimationSmall_6: 'MarbleDropAnimationSmall/6',
  _MarbleDropAnimationSmall_7: 'MarbleDropAnimationSmall/7',
  _mmAnimations_5: 'mmAnimations/5',
  _mm_assets_Marble1: 'mm_assets/Marble1',
  _mm_common_assets_Marble1: 'mm_common_assets/Marble1',
  _MarbleDropAnimationSmall_8: 'MarbleDropAnimationSmall/8',
  _mmAnimations_18: 'mmAnimations/18',
  _mmAnimations_14: 'mmAnimations/14',
  _mmAnimations_12: 'mmAnimations/12',
  _mm_assets_Marble10: 'mm_assets/Marble10',
  _mm_common_assets_Marble10: 'mm_common_assets/Marble10',
  _mm_assets_Marble2: 'mm_assets/Marble2',
  _mm_common_assets_Marble2: 'mm_common_assets/Marble2',
  _mm_assets_Marble3: 'mm_assets/Marble3',
  _mm_common_assets_Marble3: 'mm_common_assets/Marble3',
  _mmAnimations_11: 'mmAnimations/11',
  _mm_assets_Marble4: 'mm_assets/Marble4',
  _mm_common_assets_Marble4: 'mm_common_assets/Marble4',
  _mmAnimations_10: 'mmAnimations/10',
  _mm_common_assets_MarbleShadow: 'mm_common_assets/MarbleShadow',
  _md_assets_BtnAdd: 'md_assets/BtnAdd',
  _MarbleDropAnimationSmall_9: 'MarbleDropAnimationSmall/9',
  _mmAnimations_13: 'mmAnimations/13',
  _mm_assets_BtnHint: 'mm_assets/BtnHint',
  _mmAnimations_3: 'mmAnimations/3',
  _md_assets_BtnMinus: 'md_assets/BtnMinus',
  _md_assets_SmallMarble1: 'md_assets/SmallMarble1',
  _md_assets_SmallMarble2: 'md_assets/SmallMarble2',
  _md_assets_SmallMarble3: 'md_assets/SmallMarble3',
  _md_assets_SmallMarble4: 'md_assets/SmallMarble4',
  _md_assets_SmallMarble5: 'md_assets/SmallMarble5',
  _md_assets_SmallMarble6: 'md_assets/SmallMarble6',
  _md_assets_SmallMarble7: 'md_assets/SmallMarble7',
  _md_assets_SmallMarble8: 'md_assets/SmallMarble8',
  _md_assets_SmallMarble9: 'md_assets/SmallMarble9',
  _mmAnimations_6: 'mmAnimations/6',
  _mmAnimations_7: 'mmAnimations/7',
  _mmAnimations_8: 'mmAnimations/8',
  _mmAnimations_9: 'mmAnimations/9',
  _mm_common_assets_BtnHelp: 'mm_common_assets/BtnHelp',
  _md_assets_DropIncorrectMark: 'md_assets/DropIncorrectMark',
  _mm_assets_Marble5: 'mm_assets/Marble5',
  _mm_common_assets_Marble5: 'mm_common_assets/Marble5',
  _mmAnimations_1: 'mmAnimations/1',
  _mm_assets_CorrectMark: 'mm_assets/CorrectMark',
  _mmAnimations_0: 'mmAnimations/0',
  _mm_assets_Marble6: 'mm_assets/Marble6',
  _mm_common_assets_Marble6: 'mm_common_assets/Marble6',
  _md_assets_DropPlus: 'md_assets/DropPlus',
  _mmAnimations_2: 'mmAnimations/2',
  _mm_assets_Marble7: 'mm_assets/Marble7',
  _mm_common_assets_Marble7: 'mm_common_assets/Marble7',
  _mm_assets_Marble8: 'mm_assets/Marble8',
  _mm_common_assets_Marble8: 'mm_common_assets/Marble8',
  _mm_assets_Marble9: 'mm_assets/Marble9',
  _mm_common_assets_Marble9: 'mm_common_assets/Marble9',
  _mm_assets_IncorrectaMark: 'mm_assets/IncorrectaMark',
  _mm_assets_QuestionIndicatorPresent: 'mm_assets/QuestionIndicatorPresent',
  _md_assets_DropEquals: 'md_assets/DropEquals',
  _mm_assets_QuestionIndicatorFuture: 'mm_assets/QuestionIndicatorFuture',
  _mm_assets_QuestionIndicatorPast: 'mm_assets/QuestionIndicatorPast',
  _mmAnimations_19: 'mmAnimations/19',
  _PenguinTalking_22: 'PenguinTalking/22',
  _PenguinTalking_23: 'PenguinTalking/23',
  _PenguinTalking_24: 'PenguinTalking/24',
  _PenguinTalking_25: 'PenguinTalking/25',
  _PenguinTalking_3: 'PenguinTalking/3',
  _MarbleDropAnimationSmall_16: 'MarbleDropAnimationSmall/16',
  _MarbleDropAnimationSmall_1: 'MarbleDropAnimationSmall/1',
  _PenguinTalking_55: 'PenguinTalking/55',
  _PenguinTalking_70: 'PenguinTalking/70',
  _PenguinTalking_73: 'PenguinTalking/73',
  _PenguinTalking_74: 'PenguinTalking/74',
  _PenguinTalking_75: 'PenguinTalking/75',
  _MarbleDropAnimationSmall_2: 'MarbleDropAnimationSmall/2',
  _MarbleDropAnimationSmall_3: 'MarbleDropAnimationSmall/3',
  _PenguinTalking_76: 'PenguinTalking/76',
  _PenguinTalking_33: 'PenguinTalking/33',
  _PenguinTalking_34: 'PenguinTalking/34',
  _PenguinTalking_35: 'PenguinTalking/35',
  _mmAnimations_43: 'mmAnimations/43',
  _mm_assets_RoundSelect5: 'mm_assets/RoundSelect5',
  _mmAnimations_139: 'mmAnimations/139',
  _mmAnimations_143: 'mmAnimations/143',
  _PenguinTalking_36: 'PenguinTalking/36',
  _PenguinTalking_13: 'PenguinTalking/13',
  _PenguinTalking_37: 'PenguinTalking/37',
  _PenguinTalking_38: 'PenguinTalking/38',
  _mmAnimations_42: 'mmAnimations/42',
  _mmAnimations_44: 'mmAnimations/44',
  _PenguinTalking_39: 'PenguinTalking/39',
  _PenguinTalking_14: 'PenguinTalking/14',
  _PenguinTalking_82: 'PenguinTalking/82',
  _PenguinTalking_83: 'PenguinTalking/83',
  _mmAnimations_45: 'mmAnimations/45',
  _mmAnimations_138: 'mmAnimations/138',
  _PenguinTalking_84: 'PenguinTalking/84',
  _PenguinTalking_15: 'PenguinTalking/15',
  _PenguinTalking_85: 'PenguinTalking/85',
  _PenguinTalking_66: 'PenguinTalking/66',
  _mmAnimations_144: 'mmAnimations/144',
  _mmAnimations_149: 'mmAnimations/149',
  _PenguinTalking_67: 'PenguinTalking/67',
  _PenguinTalking_68: 'PenguinTalking/68',
  _PenguinTalking_26: 'PenguinTalking/26',
  _PenguinTalking_27: 'PenguinTalking/27',
  _mmAnimations_39: 'mmAnimations/39',
  _mmAnimations_40: 'mmAnimations/40',
  _PenguinTalking_28: 'PenguinTalking/28',
  _PenguinTalking_10: 'PenguinTalking/10',
  _PenguinTalking_11: 'PenguinTalking/11',
  _PenguinTalking_29: 'PenguinTalking/29',
  _mmAnimations_46: 'mmAnimations/46',
  _mmAnimations_47: 'mmAnimations/47',
  _mmAnimations_148: 'mmAnimations/148',
  _mmAnimations_30: 'mmAnimations/30',
  _PenguinTalking_30: 'PenguinTalking/30',
  _PenguinTalking_12: 'PenguinTalking/12',
  _PenguinTalking_16: 'PenguinTalking/16',
  _PenguinTalking_41: 'PenguinTalking/41',
  _mmAnimations_32: 'mmAnimations/32',
  _mmAnimations_147: 'mmAnimations/147',
  _PenguinTalking_42: 'PenguinTalking/42',
  _PenguinTalking_17: 'PenguinTalking/17',
  _PenguinTalking_60: 'PenguinTalking/60',
  _PenguinTalking_43: 'PenguinTalking/43',
  _mmAnimations_31: 'mmAnimations/31',
  _PenguinTalking_44: 'PenguinTalking/44',
  _PenguinTalking_61: 'PenguinTalking/61',
  _PenguinTalking_62: 'PenguinTalking/62',
  _PenguinTalking_45: 'PenguinTalking/45',
  _PenguinTalking_46: 'PenguinTalking/46',
  _PenguinTalking_63: 'PenguinTalking/63',
  _mmAnimations_151: 'mmAnimations/151',
  _mm_assets_RoundSelect1: 'mm_assets/RoundSelect1',
  _PenguinTalking_48: 'PenguinTalking/48',
  _PenguinTalking_77: 'PenguinTalking/77',
  _mm_assets_ChoiceBg: 'mm_assets/ChoiceBg',
  _MarbleDropAnimationSmall_12: 'MarbleDropAnimationSmall/12',
  _PenguinTalking_78: 'PenguinTalking/78',
  _PenguinTalking_79: 'PenguinTalking/79',
  _PenguinTalking_87: 'PenguinTalking/87',
  _PenguinTalking_88: 'PenguinTalking/88',
  _PenguinTalking_64: 'PenguinTalking/64',
  _PenguinTalking_89: 'PenguinTalking/89',
  _PenguinTalking_91: 'PenguinTalking/91',
  _PenguinTalking_0: 'PenguinTalking/0',
  _PenguinTalking_2: 'PenguinTalking/2',
  _PenguinTalking_20: 'PenguinTalking/20',
  _PenguinTalking_21: 'PenguinTalking/21',
  _PenguinTalking_4: 'PenguinTalking/4',
  _PenguinTalking_5: 'PenguinTalking/5',
  _PenguinTalking_52: 'PenguinTalking/52',
  _PenguinTalking_53: 'PenguinTalking/53',
  _PenguinTalking_54: 'PenguinTalking/54',
  _PenguinTalking_56: 'PenguinTalking/56',
  _PenguinTalking_57: 'PenguinTalking/57',
  _PenguinTalking_58: 'PenguinTalking/58',
  _PenguinTalking_59: 'PenguinTalking/59',
  _PenguinTalking_6: 'PenguinTalking/6',
  _PenguinTalking_7: 'PenguinTalking/7',
  _PenguinTalking_71: 'PenguinTalking/71',
  _PenguinTalking_72: 'PenguinTalking/72',
  _PenguinTalking_94: 'PenguinTalking/94',
  _PenguinTalking_95: 'PenguinTalking/95',
  _PenguinTalking_65: 'PenguinTalking/65',
  _PenguinTalking_69: 'PenguinTalking/69',
  _PenguinTalking_8: 'PenguinTalking/8',
  _PenguinTalking_9: 'PenguinTalking/9',
  _mmAnimations_33: 'mmAnimations/33',
  _mmAnimations_145: 'mmAnimations/145',
  _mmAnimations_146: 'mmAnimations/146',
  _mmAnimations_34: 'mmAnimations/34',
  _mmAnimations_38: 'mmAnimations/38',
  _mmAnimations_48: 'mmAnimations/48',
  _mmAnimations_159: 'mmAnimations/159',
  _mmAnimations_133: 'mmAnimations/133',
  _mmAnimations_137: 'mmAnimations/137',
  _mmAnimations_27: 'mmAnimations/27',
  _mmAnimations_35: 'mmAnimations/35',
  _mmAnimations_36: 'mmAnimations/36',
  _mmAnimations_37: 'mmAnimations/37',
  _mmAnimations_152: 'mmAnimations/152',
  _mmAnimations_49: 'mmAnimations/49',
  _mmAnimations_136: 'mmAnimations/136',
  _mmAnimations_28: 'mmAnimations/28',
  _mmAnimations_29: 'mmAnimations/29',
  _mmAnimations_24: 'mmAnimations/24',
  _mmAnimations_51: 'mmAnimations/51',
  _mmAnimations_54: 'mmAnimations/54',
  _mmAnimations_60: 'mmAnimations/60',
  _mmAnimations_21: 'mmAnimations/21',
  _mmAnimations_108: 'mmAnimations/108',
  _mmAnimations_62: 'mmAnimations/62',
  _mmAnimations_63: 'mmAnimations/63',
  _mmAnimations_50: 'mmAnimations/50',
  _mmAnimations_64: 'mmAnimations/64',
  _mmAnimations_22: 'mmAnimations/22',
  _mmAnimations_26: 'mmAnimations/26',
  _mmAnimations_57: 'mmAnimations/57',
  _mmAnimations_109: 'mmAnimations/109',
  _mmAnimations_23: 'mmAnimations/23',
  _mmAnimations_52: 'mmAnimations/52',
  _mmAnimations_53: 'mmAnimations/53',
  _mmAnimations_55: 'mmAnimations/55',
  _mmAnimations_56: 'mmAnimations/56',
  _mmAnimations_58: 'mmAnimations/58',
  _mmAnimations_110: 'mmAnimations/110',
  _mmAnimations_59: 'mmAnimations/59',
  _mmAnimations_61: 'mmAnimations/61',
  _mmAnimations_112: 'mmAnimations/112',
  _mmAnimations_157: 'mmAnimations/157',
  _mmAnimations_162: 'mmAnimations/162',
  _mmAnimations_25: 'mmAnimations/25',
  _mmAnimations_105: 'mmAnimations/105',
  _mmAnimations_107: 'mmAnimations/107',
  _mmAnimations_113: 'mmAnimations/113',
  _mmAnimations_120: 'mmAnimations/120',
  _mmAnimations_121: 'mmAnimations/121',
  _mmAnimations_123: 'mmAnimations/123',
  _mmAnimations_124: 'mmAnimations/124',
  _mmAnimations_125: 'mmAnimations/125',
  _mmAnimations_126: 'mmAnimations/126',
  _mmAnimations_72: 'mmAnimations/72',
  _mmAnimations_75: 'mmAnimations/75',
  _mmAnimations_76: 'mmAnimations/76',
  _mmAnimations_78: 'mmAnimations/78',
  _mmAnimations_79: 'mmAnimations/79',
  _mmAnimations_80: 'mmAnimations/80',
  _mmAnimations_81: 'mmAnimations/81',
  _mmAnimations_82: 'mmAnimations/82',
  _mmAnimations_83: 'mmAnimations/83',
  _mmAnimations_84: 'mmAnimations/84',
  _mmAnimations_85: 'mmAnimations/85',
  _mmAnimations_70: 'mmAnimations/70',
  _mmAnimations_86: 'mmAnimations/86',
  _mmAnimations_87: 'mmAnimations/87',
  _mmAnimations_88: 'mmAnimations/88',
  _mmAnimations_89: 'mmAnimations/89',
  _mmAnimations_71: 'mmAnimations/71',
  _mmAnimations_73: 'mmAnimations/73',
  _mmAnimations_74: 'mmAnimations/74',
  _mmAnimations_77: 'mmAnimations/77',
  _mmAnimations_90: 'mmAnimations/90',
  _mmAnimations_91: 'mmAnimations/91',
  _mmAnimations_92: 'mmAnimations/92',
  _mmAnimations_93: 'mmAnimations/93',
  _mmAnimations_127: 'mmAnimations/127',
  _mmAnimations_153: 'mmAnimations/153',
  _mmAnimations_154: 'mmAnimations/154',
  _mmAnimations_155: 'mmAnimations/155',
  _mmAnimations_164: 'mmAnimations/164',
  _mmAnimations_95: 'mmAnimations/95',
  _mmAnimations_96: 'mmAnimations/96',
  _mmAnimations_97: 'mmAnimations/97',
  _mmAnimations_99: 'mmAnimations/99',
  _mmAnimations_100: 'mmAnimations/100',
  _mmAnimations_101: 'mmAnimations/101',
  _mmAnimations_102: 'mmAnimations/102',
  _mmAnimations_103: 'mmAnimations/103',
  _mmAnimations_104: 'mmAnimations/104',
  _mmAnimations_106: 'mmAnimations/106',
  _mmAnimations_114: 'mmAnimations/114',
  _mmAnimations_115: 'mmAnimations/115',
  _mmAnimations_116: 'mmAnimations/116',
  _mmAnimations_117: 'mmAnimations/117',
  _mmAnimations_118: 'mmAnimations/118',
  _mmAnimations_119: 'mmAnimations/119',
  _mmAnimations_122: 'mmAnimations/122',
  _mmAnimations_128: 'mmAnimations/128',
  _mmAnimations_129: 'mmAnimations/129',
  _mmAnimations_135: 'mmAnimations/135',
  _mmAnimations_20: 'mmAnimations/20',
  _mmAnimations_65: 'mmAnimations/65',
  _mmAnimations_66: 'mmAnimations/66',
  _mmAnimations_67: 'mmAnimations/67',
  _mmAnimations_68: 'mmAnimations/68',
  _mmAnimations_69: 'mmAnimations/69',
  _mmAnimations_94: 'mmAnimations/94',
  _mmAnimations_98: 'mmAnimations/98',
  _mmAnimations_111: 'mmAnimations/111',
  _mmAnimations_130: 'mmAnimations/130',
  _mmAnimations_131: 'mmAnimations/131',
  _mmAnimations_134: 'mmAnimations/134',
  _mmAnimations_156: 'mmAnimations/156',
  _mmAnimations_158: 'mmAnimations/158',
  _mmAnimations_161: 'mmAnimations/161',
  _mmAnimations_163: 'mmAnimations/163',
  _mmAnimations_132: 'mmAnimations/132',
}